import { Container, Alert,Table, Modal, Button} from 'react-bootstrap';
import {Sida,Rubrik,ContentWrapper} from "../ContentStyles";

import { FaFilePdf, FaReceipt, FaCamera, FaInfo, FaUser, FaShoppingBasket, FaStore} from 'react-icons/fa';
import React, {useMemo, useState, useEffect } from 'react';
import {useParams, useNavigate, useSearchParams} from 'react-router-dom';
import MaterialReactTable from 'material-react-table';
import useBackend, {CallAPI, Loading, SpinnerX} from '../../services/useBackend_v2';
import ReactPlayer from 'react-player';
import { DateTimeToLocal } from '../../services/misc';
import {ModalCustomerEdit} from './Customers'

import {Branding} from '../../services/misc';

export default function MyComponent() {
    const [modalshow,  setModalshow] = useState(false);
    const initModal = () => { return setModalshow(!modalshow) } 

    const [modalvideoshow,  setModalVideoshow] = useState(false);
    const initVideoModal = () => { return setModalVideoshow(!modalshow) }     

    const [selectedOrderGuid, setSelectedOrderGuid]    = useState(null);

    const { loading, data, Refresh, XCall, Check, initReady, resultVisible, resultText, resultVariant, setPagination, pagination, setSearchFilter} =  useBackend('/api/admin/orders2', true);
    const { loading: registerDataLoading, data: registerData } = useBackend(process.env.PUBLIC_URL + '/api/admin/Register');

    const orderRowClick = async (event, rowData)  => {
        setSelectedOrderGuid(rowData.original.Guid)
        setModalshow(!modalshow);
    }

    async function closeAndRefresh() {
        setModalshow(false);
        Refresh();
    }    

    const showVideoClick = (event)  =>  {
        const OrderGUID = event.currentTarget.getAttribute("orderguid");
        setModalVideoshow(!modalvideoshow);
    }      
    
    const columns = useMemo(() => [
        { size: 20, accessorKey: 'SerialNumber', header: '#', enableColumnActions: false },

        { size: 20, header: 'Tid'           , enableColumnActions: false,
            Cell: ({ row }) => ( <span>{DateTimeToLocal(row.original.Created)}</span> ),
        }, 
    
        { size: 20, header: 'Butik'           , enableColumnActions: true,
            Cell: ({ row }) => ( <span>{row.original.Shop.Name}/{row.original.Shop.Description}</span> ),
        },         

        { size: 20, header: 'Kund'           , enableColumnActions: false,
            Cell: ({ row }) => ( <span>{row.original.Customer.SSN}/{row.original.Customer.Name}</span> ),
        },

        { size: 10, accessorKey: 'StateText',  header: 'Status', enableColumnActions: false },
      ]
    );
    
    const initialState = { 
        density: 'compact',
        columnVisibility: { Butik: false, Kund:true, 'SerialNumber':true },
        pagination
    };
    
    const state = { pagination };      

    if (initReady && !registerDataLoading) {
        return (
            <ContentWrapper>
                <ModalOrderEdit modalshow={modalshow} onHide={closeAndRefresh} OrderGuid={selectedOrderGuid} registerData={registerData}></ModalOrderEdit>

                {/* <Modal show={modalvideoshow} onHide={initVideoModal}>
                  <Modal.Header closeButton>
                      <Modal.Title>{selectedOrderData.Shop.Description} ({selectedOrderData.SerialNumber})</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>                
                    <ReactPlayer className='react-player fixed-bottom_' width="100%" controls={true} url= {"https://www.nookshop.se/static/movie/"+selectedOrderData.Guid+".mp4"} />
                  
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="danger" onClick={initVideoModal}>Close</Button>
                  </Modal.Footer>
                </Modal>                 */}

                <Container>
                    <Sida>                    
                        <MaterialReactTable 
                            enableColumnActions= {false}
                            columns={columns}
                            data={data.Orders}
                            rowCount= {data.totalNumOfRows}

                            manualPagination= {true}
                            onPaginationChange={setPagination} 
                            paginationDisplayMode='pages'
                            
                            muiSearchTextFieldProps = {{ placeholder: 'Sök på namn...' }}
                            enableGlobalFilter = {true} // Visa sökruta
					        manualFiltering = {true}  // Stänger av klientfiltrering
                            onGlobalFilterChange={(search) => { 
                                if (search!=undefined) { setSearchFilter("seekParam=" + search, 750);} 
                                else { setSearchFilter("" + search, 750);}
                            }}

                            muiTablePaperProps={{elevation: 0, sx: {borderRadius: '0',border: '0px dashed #e0e0e0'} }} 
                            muiTablePaginationProps={{ showFirstButton: true, showLastButton: true ,labelRowsPerPage:"Rader", rowsPerPageOptions: [25, 50, 100]}}
                            state={state}
                            initialState={initialState}
                            renderTopToolbarCustomActions={() => (<Rubrik>Besök</Rubrik>)} 

                            muiTableBodyRowProps={({ row }) => ({
                                onClick: (event) => { orderRowClick(event, row); }, sx: { cursor: 'pointer', }, elevation: 0, sx: {borderRadius: '0',border: '0px dashed #e0e0e0'} 
                            })}
                        />                    
                    </Sida>
                </Container>
            </ContentWrapper>
        );
    } else {
        return (<Loading />);         
    }
}

export function ModalOrderEdit(props) {
    const { loading, data, initReady, Refresh, resultVariant, resultVisible, resultText, resultSuccess, ReInit, Update, XCall, GUIDx } = useBackend('');
    const defaultValues              = {Customer: {Guid:null}, Shop : {Description:"", SerialNumber:"" }, BasketItemList: []};
    const [selectedOrderData, setSelectedOrderData]    = useState(defaultValues);
    const [editCustomerModalshow,  setEditCustomerModalshow] = useState(false);

    const navigate = useNavigate();

    async function closeForm() {
        setSelectedOrderData(defaultValues); 
        props.onHide();        
    }
    
    async function showForm() {                 
        let {resultVariant, resultVisible, resultText, errorsException, jsondata} = await CallAPI('/api/admin/orders/' + props.OrderGuid, "GET");        
        setSelectedOrderData(jsondata);
    }

    const setOrderStateClick = async (event)  =>  {
        const NewState = event.currentTarget.getAttribute("newstate");
		await CallAPI('/api/admin/Orders/'+selectedOrderData.Guid,"PATCH","{\"NewOrderState\":\"10\"}");
        
        let {resultVariant, resultVisible, resultText, errorsException, jsondata} = await CallAPI('/api/admin/orders/' + props.OrderGuid, "GET");        
        setSelectedOrderData(jsondata);        
        // Refresh();
    }    

    function getOptions(object) {
        return object.map((key) => {
            return <option key={key.Id} value={key.Id}>{key.Name}</option>;
        });
    }

    if (true) {
    return (
                <>
                <ModalCustomerEdit modalshow={editCustomerModalshow} onHide={() => {setEditCustomerModalshow(!editCustomerModalshow);}} CustomerGuid={selectedOrderData.Customer.Guid} registerData={props.registerData} ></ModalCustomerEdit>

                <Modal show={props.modalshow} onHide={() => closeForm()} onShow={() => showForm()}>
                    <Modal.Header closeButton>
                        <Modal.Title>{selectedOrderData.Shop.Description} ({selectedOrderData.SerialNumber})</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>

                    <Table  responsive="sm">
                        <tbody>
                            <tr><td>Butik</td><td colSpan={2}>{selectedOrderData.Shop.Name}/{selectedOrderData.Shop.Description}</td></tr>
                            <tr><td>Skapad</td><td colSpan={2}>{DateTimeToLocal(selectedOrderData.Created)}</td></tr>
                            <tr><td>Ordernr</td><td colSpan={2}>{selectedOrderData.SerialNumber}<br/><small>{selectedOrderData.Guid}</small></td></tr>
                            <tr>
                                <td>Kund</td><td>{selectedOrderData.Customer.Name}<br/>{selectedOrderData.Customer.SSN}<br/>{selectedOrderData.Customer.eMail} </td>
                                <td><Button variant="info" style={{width:"100px"}} onClick={() => {setEditCustomerModalshow(true);}}>Info</Button></td>
                            </tr>
                            <tr>
                                <td>Status</td><td colSpan={1}>{selectedOrderData.OrderStateText}</td>
                                <td>{selectedOrderData.OrderState!=5 && ( <Button variant="danger" style={{width:"100px"}} type="button" orderguid={selectedOrderData.Guid} onClick={setOrderStateClick} newstate="10">Makulera</Button> )}</td>
                            </tr>
                            <tr><td>Betalmetod</td><td colSpan={2}>{selectedOrderData.PaymentMethodText}<br/><small>{selectedOrderData.PaymentReference}</small></td></tr>
                        </tbody>
                    </Table>

                    <Table  responsive="sm">
                        <tbody>
                            <tr> <th>Name</th><th>Moms</th> <th>Antal</th>  <th>Pris</th> </tr>
                            {selectedOrderData.BasketItemList.map((item) => {
                                return <tr>
                                    <td>{item.Name}</td>
                                    <td>{item.Vat} %</td>
                                    <td>{item.Qty}</td>
                                    <td>{item.Price}</td>
                                </tr>
                            })}
                            <tr> <th>Totalt</th> <td colSpan={2}>{selectedOrderData.BasketTotalVat}</td> <td>{selectedOrderData.BasketTotalAmount}</td>   </tr>
                        </tbody>                        
                    </Table>                    
                 
                    </Modal.Body>
                    <Modal.Footer>
                        {/* <Button className={(selectedOrderData.HasVideo ? ("QmeButton"):("QmeButtonDisabled"))}   style={{backgroundColor:Branding().ButtonColor}} variant="primary" type="button" orderguid={selectedOrderData.Guid} onClick={showVideoClick} disabled={!selectedOrderData.HasVideo}><FaCamera/></Button> */}
                        
                        <div style={{marginRight:"24px"}}>
                            <Button variant="danger" style={{width:"100px"}} onClick={closeForm}>Close</Button>
                        </div>
                    </Modal.Footer>
                </Modal>      
                </>
    );
        } else {
            return (<Loading />);        
        }
}